import type { CalendarSlot } from './preview-calendar';

/** Search-only capacity filter; the booking calendar still validates the actual party. */
export function accommodatesSearchParty(slot: CalendarSlot, passengers: number): boolean {
  return Number.isInteger(passengers) && passengers > 0 && slot.available && !slot.soldOut
    && passengers >= slot.minParticipants && (slot.unlimited || (slot.capacity ?? 0) >= passengers);
}

export function pickupSummary(confirmed: number, total: number, complete: boolean, hotelSelected: boolean): string | null {
  return complete && hotelSelected ? `${confirmed} de ${total} tours te recogen en tu hotel` : null;
}